import {
  AccessTime, Image, Message, MicNone, Videocam
} from "@mui/icons-material";
import React, { memo, useState, useContext } from "react";
import { Handle, useReactFlow } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { WhatsAppsContext } from "../../../context/WhatsApp/WhatsAppsContext";

const TrashIcon = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor">
    <path d="M9 3V4H4V6H5V20C5 21.1 5.9 22 7 22H17C18.1 22 19 21.1 19 20V6H20V4H15V3H9ZM7 6H17V20H7V6ZM9 8V18H11V8H9ZM13 8V18H15V8H13Z"/>
  </svg>
);
const DupeIcon = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor">
    <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
  </svg>
);
const EditIcon = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor">
    <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
  </svg>
);
const WA_ICON = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="white">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

const TYPE_ICON = {
  message:  <Message sx={{ color: "#3b82f6", fontSize: 14 }} />,
  interval: <AccessTime sx={{ color: "#f59e0b", fontSize: 14 }} />,
  img:      <Image sx={{ color: "#8b5cf6", fontSize: 14 }} />,
  audio:    <MicNone sx={{ color: "#10b981", fontSize: 14 }} />,
  video:    <Videocam sx={{ color: "#ec4899", fontSize: 14 }} />,
};
const TYPE_COLOR = {
  message: "#3b82f6", interval: "#f59e0b", img: "#8b5cf6", audio: "#10b981", video: "#ec4899",
};

const HANDLES = [
  { id: "link",       label: "Se clicar em algum link", dot: "#eab308" },
  { id: "responded",  label: "Se responder",            dot: "#22c55e" },
  { id: "nresponded", label: "Se não responder",        dot: "#ef4444" },
  { id: "a",          label: "Próxima etapa",           dot: "#94a3b8" },
];

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();
  const { setNodes } = useReactFlow();
  const { whatsApps } = useContext(WhatsAppsContext);
  const [showWASelector, setShowWASelector] = useState(false);
  const [editingLabel, setEditingLabel] = useState(false);

  const connectedWAs = whatsApps ? whatsApps.filter(w => w.status === "CONNECTED") : [];

  const selectedWA = connectedWAs.find(w => w.id === data.whatsappId) || connectedWAs[0];

  const updateData = (patch) => {
    setNodes(old => old.map(n => n.id === id ? { ...n, data: { ...n.data, ...patch } } : n));
  };

  return (
    <div style={{
      background: "#ffffff",
      borderRadius: 14,
      border: "1.5px solid rgba(34, 197, 94, 0.22)",
      boxShadow: "0 4px 16px rgba(34, 197, 94, 0.08), 0 1px 4px rgba(0,0,0,0.04)",
      width: 248,
      fontFamily: "Inter, ui-sans-serif, system-ui, sans-serif",
      position: "relative",
      overflow: "visible",
    }}>

      {/* Action buttons */}
      <div style={{ position: "absolute", top: -32, right: 0, display: "flex", gap: 6 }}>
        <button
          style={{ width: 26, height: 26, borderRadius: "50%", background: "#6366f1", border: "none", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "#fff" }}
          title="Editar conteúdo"
          onClick={() => { storageItems.setNodesStorage(id); storageItems.setAct("edit"); }}
        ><EditIcon /></button>
        <button
          style={{ width: 26, height: 26, borderRadius: "50%", background: "#3b82f6", border: "none", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "#fff" }}
          title="Duplicar"
          onClick={() => { storageItems.setNodesStorage(id); storageItems.setAct("duplicate"); }}
        ><DupeIcon /></button>
        <button
          style={{ width: 26, height: 26, borderRadius: "50%", background: "#ef4444", border: "none", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "#fff" }}
          title="Excluir"
          onClick={() => { storageItems.setNodesStorage(id); storageItems.setAct("delete"); }}
        ><TrashIcon /></button>
      </div>

      {/* Input handle */}
      <Handle
        type="target"
        position="left"
        style={{
          background: "#22c55e", width: 14, height: 14,
          left: -8, top: 28,
          border: "2px solid #fff",
          boxShadow: "0 2px 8px rgba(34,197,94,0.35)",
        }}
        isConnectable={isConnectable}
      />

      {/* Header */}
      <div style={{
        display: "flex", alignItems: "center", gap: 8,
        padding: "10px 12px 8px",
        borderBottom: "1px solid rgba(34,197,94,0.10)",
      }}>
        {/* WA icon — click to show selector */}
        <div
          style={{
            width: 30, height: 30, borderRadius: "50%",
            background: "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)",
            display: "flex", alignItems: "center", justifyContent: "center",
            flexShrink: 0, boxShadow: "0 4px 10px rgba(34,197,94,0.28)",
            cursor: connectedWAs.length > 1 ? "pointer" : "default",
            position: "relative",
          }}
          onMouseDown={e => { e.stopPropagation(); if (connectedWAs.length > 0) setShowWASelector(v => !v); }}
          title={connectedWAs.length > 1 ? "Trocar WhatsApp" : ""}
        >
          <WA_ICON />
          {/* WA dropdown */}
          {showWASelector && (
            <div
              style={{
                position: "absolute", top: 34, left: 0, zIndex: 9999,
                background: "#fff", borderRadius: 10, boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
                border: "1px solid rgba(34,197,94,0.20)", minWidth: 180, padding: "4px 0",
              }}
              onMouseDown={e => e.stopPropagation()}
            >
              <div style={{ fontSize: 10, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.05em", padding: "6px 12px 4px" }}>
                WhatsApp
              </div>
              {connectedWAs.map(wa => (
                <div
                  key={wa.id}
                  onMouseDown={e => { e.stopPropagation(); updateData({ whatsappId: wa.id }); setShowWASelector(false); }}
                  style={{
                    padding: "7px 12px", fontSize: 12.5, cursor: "pointer",
                    background: data.whatsappId === wa.id ? "rgba(34,197,94,0.08)" : "transparent",
                    color: data.whatsappId === wa.id ? "#15803d" : "#0f172a",
                    display: "flex", alignItems: "center", gap: 8,
                    fontWeight: data.whatsappId === wa.id ? 600 : 400,
                  }}
                >
                  <span style={{ width: 7, height: 7, borderRadius: "50%", background: "#22c55e", flexShrink: 0, display: "inline-block" }} />
                  {wa.name}
                  {data.whatsappId === wa.id && (
                    <span style={{ marginLeft: "auto", fontSize: 10, color: "#22c55e" }}>✓</span>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>

        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 700, fontSize: 12.5, color: "#0f172a", letterSpacing: "-0.01em" }}>
            Enviar WhatsApp
          </div>
          {/* Optional name label */}
          {editingLabel ? (
            <input
              autoFocus
              defaultValue={data.nodeLabel || ""}
              onMouseDown={e => e.stopPropagation()}
              onBlur={e => { updateData({ nodeLabel: e.target.value }); setEditingLabel(false); }}
              onKeyDown={e => { if (e.key === "Enter") { updateData({ nodeLabel: e.target.value }); setEditingLabel(false); } if (e.key === "Escape") setEditingLabel(false); }}
              placeholder="Nome opcional..."
              style={{
                fontSize: 10.5, border: "1px solid #22c55e", borderRadius: 4, padding: "1px 5px",
                outline: "none", width: "100%", background: "#f0fdf4", color: "#15803d",
                fontFamily: "inherit",
              }}
            />
          ) : (
            <div
              onMouseDown={e => { e.stopPropagation(); setEditingLabel(true); }}
              style={{
                fontSize: 10.5, color: data.nodeLabel ? "#15803d" : "#94a3b8",
                cursor: "text", fontStyle: data.nodeLabel ? "normal" : "italic",
                overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
              }}
              title="Clique para nomear este bloco"
            >
              {data.nodeLabel || (selectedWA ? selectedWA.name : "Clique para nomear...")}
            </div>
          )}
        </div>
      </div>

      {/* Messages preview */}
      {data.seq && data.seq.length > 0 && (
        <div style={{ padding: "8px 10px 6px", display: "flex", flexDirection: "column", gap: 5 }}>
          {data.seq.map((item) => {
            const element = data.elements?.find(el => el.number === item);
            const typeKey = Object.keys(TYPE_ICON).find(k => item.includes(k)) || "message";
            const color = TYPE_COLOR[typeKey] || "#22c55e";
            return (
              <div key={item} style={{
                display: "flex", alignItems: "flex-start", gap: 7,
                padding: "5px 8px", borderRadius: 8,
                background: "#f8fafc", border: `1px solid ${color}22`,
              }}>
                <div style={{
                  width: 20, height: 20, borderRadius: 5,
                  background: `${color}18`,
                  display: "flex", alignItems: "center", justifyContent: "center",
                  flexShrink: 0, marginTop: 1,
                }}>
                  {TYPE_ICON[typeKey]}
                </div>
                <div style={{
                  fontSize: 10.5, color: "#374151", lineHeight: 1.4, flex: 1,
                  overflow: "hidden", display: "-webkit-box",
                  WebkitLineClamp: 2, WebkitBoxOrient: "vertical",
                }}>
                  {element?.value || element?.original || <span style={{ color: "#94a3b8", fontStyle: "italic" }}>Mensagem...</span>}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Output handles section */}
      <div style={{ borderTop: "1px solid rgba(15,23,42,0.06)", padding: "5px 0 3px" }}>
        {HANDLES.map((h) => (
          <div key={h.id} style={{
            display: "flex", alignItems: "center", justifyContent: "flex-end",
            gap: 8, padding: "4px 12px 4px 0", position: "relative",
          }}>
            <span style={{ fontSize: 11, fontWeight: 500, color: h.id === "a" ? "#94a3b8" : "#374151" }}>
              {h.label}
            </span>
            <span style={{
              width: 9, height: 9, borderRadius: "50%",
              background: h.dot, flexShrink: 0,
              boxShadow: `0 2px 5px ${h.dot}55`,
            }} />
            <Handle
              type="source"
              position="right"
              id={h.id}
              style={{
                right: -7, top: "50%", transform: "translateY(-50%)",
                width: 10, height: 10,
                background: h.dot, border: "2px solid #fff",
                boxShadow: `0 2px 5px ${h.dot}55`,
                position: "absolute",
              }}
              isConnectable={isConnectable}
            />
          </div>
        ))}
      </div>
    </div>
  );
});
